import { useEffect } from "react";

import { useAuthContext } from "./useAuthContext";
import { apiService } from "../services/apiService";

export function useApiService() {
  const { idToken } = useAuthContext();

  useEffect(() => {
    apiService.setToken(idToken);
  }, [idToken]);

  return apiService;
}
